import {message} from '@sail/intl';
import type {ConnectElementConfig} from '../ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

const messages = {
  errorText: message({
    id: 'connectEmbed.balanceReport.errorBoundary.text',
    defaultMessage: 'Your balance report cannot be loaded.',
    description: 'Message shown when an unhandled report error is caught',
  }),
};

export const BalanceReportConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "balanceReport" */ '../../../components/Reporting/BalanceReport/BalanceReport'
    ),
  messageOverrides: messages,
  releaseState: 'internal',
  enabledKey: 'balance_report',
  enabledOverrideFlag: ComponentOverrideFlag.balance_report,
  sentryTeam: 'accounts_ui',
  teamOwner: 'connected-account-experiences-eng',
  description: 'Displays the balance report for a connected account.',
  friendlyName: 'Balance report',
};
